import { useQuery } from 'hooks/useCustomQuery';
import getAllNumbersList from 'API/Numbers/getAllNumbersList';
import ScopeType from 'utils/enums/ScopeType';

/**
 * (3129) Every number under the company, from the same numbers summary the
 * Numbers page lists. Always company-scoped: the dashboard is a company view
 * whatever scope the header is on.
 */
const useGetCompanyNumbers = (companyId, options = {}) =>
    useQuery({
        queryKey: ['setupProgress', 'numbers', companyId],
        queryFn: async () => {
            const data = await getAllNumbersList(
                ScopeType.COMPANY,
                null,
                null,
                companyId,
            );
            return data?.numbers || [];
        },
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetCompanyNumbers;
